import { Card, CardContent } from "@/components/ui/card";
import { Settings, Link2, Mail, CreditCard } from "lucide-react";

export default function IntegrationsPage() {
  const integrations = [
    { name: "Microsoft 365", desc: "Email sync for invoices, quotes, and payment proofs", icon: Mail, status: "Configured", statusColor: "bg-green-50 text-green-700 border-green-200" },
    { name: "Google Cloud Vision", desc: "OCR for document scanning and data extraction", icon: Settings, status: "Active", statusColor: "bg-green-50 text-green-700 border-green-200" },
    { name: "Resend", desc: "Email sending for invoices, quotes, and notifications", icon: Mail, status: "Active", statusColor: "bg-green-50 text-green-700 border-green-200" },
  ];
  return (
    <div data-testid="integrations-page">
      <div className="mb-6"><h1 className="font-heading font-bold text-2xl text-[#1F2937]">Integrations</h1>
        <p className="text-sm text-gray-500 mt-1">Connected services and API configurations</p></div>
      <div className="space-y-3">
        {integrations.map(ig => (
          <Card key={ig.name} className="border rounded-sm"><CardContent className="p-4 flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-gray-100 text-gray-600"><ig.icon className="w-5 h-5" /></div>
            <div className="flex-1"><h3 className="font-medium text-[#1F2937]">{ig.name}</h3><p className="text-xs text-gray-500">{ig.desc}</p></div>
            <span className={`rounded-full text-xs border px-2.5 py-0.5 font-medium ${ig.statusColor}`}>{ig.status}</span>
          </CardContent></Card>
        ))}
      </div>
    </div>
  );
}
